module.exports = __webpack_public_path__ + "img/video.ea22fc44.jpg";